import { render } from "./Create2FA.vue?vue&type=template&id=46743d72"
import script from "./Create2FA.vue?vue&type=script&lang=js"
export * from "./Create2FA.vue?vue&type=script&lang=js"
script.render = render

export default script